import { Module } from "vuex";
import { State } from "@/store/modules/page_title/state";
import Mutations from "@/store/modules/page_title/mutations";
import Getters from "@/store/modules/page_title/getters";
import Actions from "@/store/modules/page_title/actions";

export class PageTitle implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
